import {  useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getSessionHistory, postQuestion } from "../../api/chatbot/chatbot";
import { useUserStore } from "../../Context/store";

// postQuestion
export const usePostQuestion = () => {
  const { user: loggedInUser } = useUserStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (questionParam) => {
      return await postQuestion({
        question: questionParam?.question,
        user_id: loggedInUser?.userId,
        session_id: loggedInUser?.sessionId,
      });
    },
        onSuccess: async () => {
          await queryClient.invalidateQueries({
            queryKey: ["chatbot-history"],
          });
        },
    onError: (error) => {
      console.log(error);
    },
  });
};
export const useGetSessionHistory = (userId, session,page,pageSize) => {
  const { user: loggedInUser } = useUserStore();
    return useQuery({
      queryKey: ["chatbot-history",page,pageSize],
      queryFn: async () => {
        return await getSessionHistory({
          user_id: loggedInUser?.userId,
          session_id: loggedInUser?.sessionId,
          page,
          pageSize
        });
      },
      select: (data) => data,
      enabled:!!loggedInUser ,

    });
  };
// sessionHistory
